import $ from 'jquery'

// Theme Switcher
// Reads the user's color scheme preference from data-bs-color-scheme (set
// server-side from user.settings_prefers_color_scheme, which the user picks in
// their settings) and resolves it to the concrete theme Bootstrap reads.
// Values: "system" (default), "light", "dark"

const resolveTheme = () => {
  const preference = document.documentElement.getAttribute('data-bs-color-scheme') || 'system'
  if (preference === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  return preference
}

const applyTheme = () => {
  // Only data-bs-theme changes here. Do not set color-scheme: Bootstrap's
  // [data-bs-theme="dark"] { color-scheme: dark } flipping with the OS is
  // what leaves iOS Safari invert artifacts; layout.sass keeps color-scheme
  // stable instead.
  document.documentElement.setAttribute('data-bs-theme', resolveTheme())
}

// Apply on initial load
applyTheme()

// Re-apply after Turbo navigation
// data-bs-color-scheme is updated by Turbo from the server response on each navigation,
// so we always re-apply to sync data-bs-theme with the (possibly changed) preference.
$(document).on('turbo:load', applyTheme)

// Listen for OS theme changes (only matters when preference is "system")
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  if ((document.documentElement.getAttribute('data-bs-color-scheme') || 'system') === 'system') {
    applyTheme()
  }
})
